import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourStepDirective } from './directives/tour-step.directive';
import { MainTourComponent } from './components/main/main-tour.component';
import { ChartHeaderTourStepDirective } from './directives/chart-header-tour-step.directive';
import { OrgchartNodeTourStepDirective } from './directives/orgchart-node-tour-step.directive';



@NgModule({
  declarations: [
    MainTourComponent,
    TourStepDirective,
    ChartHeaderTourStepDirective,
    OrgchartNodeTourStepDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MainTourComponent,
    TourStepDirective,
    ChartHeaderTourStepDirective,
    OrgchartNodeTourStepDirective
  ]
})
export class ProductTourModule { }
